import classNames from 'classnames';
import React, { FC } from 'react';

type EllipsizedTextProps = {
  text: string;
  className?: string;
};

export const EllipsizedText: FC<EllipsizedTextProps> = ({ text, className = '' }) => {
  return <div className={classNames(className, 'overflow-hidden whitespace-nowrap text-ellipsis')}>{text}</div>;
};
